export default __webpack_public_path__ + "static/media/Circle.352de020.svg";